import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import colors from '../../../../configuration/colors'
import FlexContainer from '../../../styled/FlexContainer'

const EmptyBar = styled.div`
  height: 22px;
  width: 100%;
  border-radius: 5px;
  overflow: hidden;
  background-color: ${colors.rock};
`

const ProgressBar = styled.div`
  height: inherit;
  width: inherit;
  width: ${props => props.progress}%;
  background-image: repeating-linear-gradient(
    60deg,
    ${colors.slate},
    ${colors.slate} 30px,
    #5B7990 30px,
    #5B7990 60px
  );
  background-size: ${props => ~~(7000/props.progress) + 100}% 100%;
  background-position: -70px;
  border-radius: 5px 0 0 5px;
  transition: width 0.3s ease;
  animation: loadingBarberpole 1s linear infinite;
`

const StatusText = styled.div.attrs({
  className: 'caption2'
})`
  position: absolute;
  margin-left: 10px;
  font-size: 13px;
  font-weight: 500;
`

const FileUploadProgressBar = ({ progress }) => (
  <FlexContainer style={{ width: '100%' }}>
    <EmptyBar>
      <ProgressBar progress={progress} />
    </EmptyBar>
    <StatusText>
      Uploading {progress}%
    </StatusText>
  </FlexContainer>
)

FileUploadProgressBar.propTypes = {
  progress: PropTypes.number.isRequired
}

export default FileUploadProgressBar
